import { request } from "../../utils/config"

export const GET_CHAT_MESSAGES = async (params: { channelId?: string; page?: number; pageSize?: number }) => {
  const response = await request({
    url: `Chat/GetMessages`,
    method: "GET",
    params: {
      channelId: params.channelId || "group",
      page: params.page || 1,
      pageSize: params.pageSize || 100,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

/**
 * Foydalanuvchi kira oladigan xonalar ro'yxati (RBAC talabnomasi).
 * Oddiy xodim faqat "Umumiy guruh" va "Admin bilan aloqa" ni oladi.
 */
export interface ChatChannel {
  id: string
  name: string
  type: string
  managerId: number | null
  /** O'qilmagan xabarlar soni (Telegram uslubidagi badge) */
  unreadCount: number
  lastMessageText: string | null
  lastMessageSender: string | null
  lastMessageAt: string | null
}

export const GET_CHAT_CHANNELS = async (): Promise<ChatChannel[]> => {
  const response = await request({
    url: `Chat/GetChannels`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  const raw = response.data || []
  // Backend PascalCase qaytarishi mumkin — ikkala shakl ham qo'llab-quvvatlanadi
  return raw.map((c: any) => ({
    id: c.id ?? c.Id,
    name: c.name ?? c.Name,
    type: c.type ?? c.Type,
    managerId: c.managerId ?? c.ManagerId ?? null,
    unreadCount: c.unreadCount ?? c.UnreadCount ?? 0,
    lastMessageText: c.lastMessageText ?? c.LastMessageText ?? null,
    lastMessageSender: c.lastMessageSender ?? c.LastMessageSender ?? null,
    lastMessageAt: c.lastMessageAt ?? c.LastMessageAt ?? null,
  }))
}

export const SEND_CHAT_MESSAGE = async (data: {
  channelId?: string
  senderId?: string
  senderName?: string
  receiverId?: string
  text: string
  photo?: string
  isAdmin?: boolean
}) => {
  const response = await request({
    url: `Chat/SendMessage`,
    method: "POST",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const MARK_CHAT_AS_READ = async (channelId: string) => {
  const response = await request({
    url: `Chat/MarkAsRead?channelId=${encodeURIComponent(channelId)}`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
